import React, { Component, PropTypes } from 'react';
import A from 'aphrodite';

const classNames = A.StyleSheet.create({
  container: { border: '1px solid #d5d5d5', borderRadius: '2px', margin: '15px 0 5px 0' },
  imageContainer: {
    height: 0,
    paddingTop: '52.3%',
    overflow: 'hidden',
    maxWidth: '100%',
    position: 'relative',
    margin: 0,
  },
  imageDisplay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },
});

class LinkPreview extends Component {
  render() {
    const {
      description,
      imageUrl,
      title,
      url,
      children,
    } = this.props;

    // remove http / https / www - oh lala
    const stripUrl = url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0];

    return (
      <div className={A.css(classNames.container)}>
        {
          imageUrl && <div className={A.css(classNames.imageContainer)}>
            <a href={url} target="_blank" style={{ color: 'inherit', textDecoration: 'none' }}>
              <div className={A.css(classNames.imageDisplay)} style={{ backgroundImage: `url(${imageUrl})` }} />
            </a></div>
        }
        <div style={{ display: 'block', padding: '3px 5px' }}>
          <div style={{ fontWeight: 600, fontSize: '14px', cursor: 'pointer' }}>
            <a href={url} target="_blank" style={{ color: 'inherit', textDecoration: 'none' }}>{title}</a>
          </div>
          <div style={{ fontSize: '12px', marginTop: '3px' }}>{description}</div>
          <div style={{ fontSize: '10px', marginTop: '3px', cursor: 'pointer' }}>
            <a href={url} target="_blank" style={{ color: 'inherit', textDecoration: 'none' }}>
              {(stripUrl || '').toUpperCase()}
            </a>
          </div>
          {children}
        </div>
      </div>
    );
  }
}

LinkPreview.propTypes = {
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
  siteName: PropTypes.string,
  children: PropTypes.node,
};

export default LinkPreview;



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/linkPreview.jsx